import service from '@/utils/server';

const modName='/bd/qc/';
export const pageInfo = data => {
  return service({
    url: modName + 'getRecheckPageInfo',
    method: 'post',
    data
  });
};

//开始二检
export const startRecheck = data => {
  return service({
    url: modName + 'recheck',
    method: 'post',
    data
  });
};






// WEBPACK FOOTER //
// ./src/page/bd/qc/recheck/api/index.js